import React from "react";
import { ToastContainer } from "react-toastify";
import AddBrand from "../../components/ProductManager/Brand/AddBrand";

export const AddBrandPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddBrand />
        </div>
      </div>
    </div>
  );
};
